import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ImagePreloadService {
  imageContextLoaded = new Subject<any>();

  constructor() {}

  preloadImagesWithURLs(urls, context: string, timeout: number = 10000): any {
    let self = this;
    let count = 0;
    let timedOut = false;
    if (urls && urls.length === 0) this.imageContextLoaded.next(context);
    // Filter any empty or undefined values
    urls = urls.filter(url => url && url.length);
    // Set a timeout in case one of the images fails to load
    setTimeout(() => {
      timedOut = true;
      if (count !== urls.length) console.error('Image loader timed out');
      self.imageContextLoaded.next(context);
    }, timeout);

    // Load each image
    // When all images are loaded, fire the observable
    // passing back the context ID.
    urls.forEach(url => {
      let bg = new Image();

      // When the image has loaded, if it's the last one, fire the observable
      // with the context ID
      bg.onload = function() {
        count++;
        if (count === urls.length && !timedOut) {
          self.imageContextLoaded.next(context);
        }
      };

      // Make the image start loading
      bg.src = url;
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/image-preload/image-preload.service.ts